import { DetailsPanelContextProvider } from "PFApp/booking/components/details_panel";
import PropTypes from "prop-types";
import React from "react";

import BookingPage from "./booking_page";
import { BookingModuleContextProvider } from "./parts/providers/booking_module_context_provider";
import useBookingPage from "./use_booking_page";

const BookingController = ({ section }) => {
  const initPage = {
    tab: section,
    initialized: false,
    projects: {
      data: { entries: [], meta: { total: 0, filters: [], order: { value: {} } }, loading: false },
      loaded: false
    },
    workforce: {
      data: { entries: [], meta: { total: 0, filters: [], order: { value: {} } }, loading: false },
      loaded: false
    }
  };

  const { initialized } = useBookingPage(initPage);

  return (
    initialized && (
      <DetailsPanelContextProvider>
        <BookingModuleContextProvider>
          <BookingPage />
        </BookingModuleContextProvider>
      </DetailsPanelContextProvider>
    )
  );
};

BookingController.propTypes = {
  section: PropTypes.oneOf(["overview", "approvals", "reports"])
};

export default BookingController;
